class Controller {

  constructor() {}
}

export default Controller;